var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"shop-items-all-companies-modal"}},[_c('memlist-modal',{ref:"all-shop-items-modal",attrs:{"size":"xl"}},[_c('ShopItemsAllCompaniesTable',{on:{"selected":_vm.selected_item}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }